var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-filter',{attrs:{"elements":_vm.pages,"selected":_vm.selectedPage},on:{"changed":_vm.sidebarChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }